import * as React from "react";
import { useHistory } from "react-router-dom";

import { AppLoadError } from "@/components/AppLoadError";

export const NotFoundPage: React.FC = () => {
  const history = useHistory();
  return <AppLoadError kind="notFound" onHome={() => history.push("/mypage")} />;
};
